import { TFunction } from 'i18next'
import { z } from 'zod'

import { doesStringContainHtml } from '../../../../../utils/doesStringContainHtml'
import { isValidEmail } from '../../../../../utils/isValidEmail'
import { SendAsEmailFormSchema } from '../types/sendAsEmailFormSchema'

export const getSendAsEmailFormSchema = (t: TFunction, hasFailedAttachments: boolean): SendAsEmailFormSchema => {
  return z.object({
    attachmentUuids: z
      .array(z.string())
      .refine(() => !hasFailedAttachments, {
        message: t('external_invoices.send_as_email.modal.faulty_attachment_error'),
      })
      .optional(),
    ccEmailRecipients: z
      .array(z.string().email())
      .refine((value) => value.every((email) => isValidEmail(email)), {
        message: t('external_invoices.send_as_email.modal.form.validation.invalid_email'),
      })
      .optional(),
    emailRecipients: z
      .array(z.string().email())
      .min(1, { message: t('external_invoices.send_as_email.modal.form.validation.at_least_one_recipient') })
      .refine((value) => value.every((email) => isValidEmail(email)), {
        message: t('external_invoices.send_as_email.modal.form.validation.invalid_email'),
      }),
    emailSubject: z
      .string()
      .min(1, { message: t('external_invoices.send_as_email.modal.form.validation.subject_required') })
      .refine((value) => !doesStringContainHtml(value), {
        message: t('external_invoices.send_as_email.modal.form.validation.contains_html'),
      }),
    emailMessage: z
      .string()
      .optional()
      .refine((value) => !doesStringContainHtml(value), {
        message: t('external_invoices.send_as_email.modal.form.validation.contains_html'),
      }),
    shouldSendCopyToMyself: z.boolean().optional(),
  })
}
